import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  withHandlers,
  lifecycle
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { postRefundData, getGochiOneToN } from '../../actions/Gochis';
import { sendLogin } from '../../auth/Auth';
import ProgressDialog from './ProgressDialog';

const styles = {
  root: {
    position: 'absolute',
    width: '95%',
    maxWidth: '355px',
    height: 'auto',
    maxHeight: '80%',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%,-50%)',
    backgroundColor: '#fff',
    padding: 15,
    overflow: 'auto',
    outline: 'none',
    fontSize: 12,
    lineHeight: '16px',
    color: '#333333',
    borderRadius: 4
  },
  document: {
    width: '90%',
    margin: '5px'
  },
  btnCloseDiv: {
    textAlign: 'center'
  },
  titleContent: {
    textAlign: 'center',
    marginBottom: '15px',
    marginTop: '5px'
  },
  btnClose: {
    fontSize: 14,
    fontWeight: 'bold',
    width: '100%'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      name: state.loginInfo.name
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          postRefundData,
          getGochiOneToN
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openApprovalProgress', 'updateOpenApprovalProgress', false),
  withState('openEditProgress', 'updateOpenEditProgress', false),
  withState('loading', 'setLoading', false),
  withState('isChangeSuccess', 'updateIsChangeSuccess', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('checkDisable', 'updateCheckDisable', false),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    }
  }),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    openEditProgress,
    updateOpenEditProgress,
    setOpenFullRefundPopup,
    setUpdateOpenFullRefundPopup,
    isChangeSuccess,
    updateIsChangeSuccess,
    paymentType,
    gochiBillNoo,
    checkSession,
    setResultMessage,
    resultMessage,
    merPaymentId,
    paymentIdData,
    gochiBillIdData,
    checkDisable,
    updateCheckDisable,
    loading,
    setLoading,
    chargeAmount
  }) => {
    const closeAction = () => {
      setOpenFullRefundPopup(false);
    };

    const params = {
      paymentId: paymentIdData,
      gochiBillId: gochiBillIdData,
      payType: paymentType,
      merchantPaymentId: merPaymentId,
      amount: chargeAmount,
      currency: 'JPY',
      reason: 'requested_by_customer'
    };
    const callRefund = async () => {
      setLoading(true);
      updateCheckDisable(true);
      await actions
        .postRefundData(params)
        .then(data => {
          checkSession(data);

          if (data.type === 'POST_REFUND_SUCCESS') {
            setLoading(false);
            setResultMessage('返金しました。');
            updateIsChangeSuccess(true);
            updateOpenEditProgress(true);
            setUpdateOpenFullRefundPopup(true);
          } else {
            // TODO: show failed message
            setLoading(false);
            updateOpenEditProgress(true);
            updateIsChangeSuccess(false);
            setResultMessage('返金に失敗しました。');
          }
        })
        .catch(() => {
          // TODO: show failed message
          setLoading(false);
          updateOpenEditProgress(true);
          updateIsChangeSuccess(false);
          setResultMessage('返金に失敗しました。');
        });
    };

    const progressOkAction = async () => {
      if (isChangeSuccess) {
        const searchKey = {
          gochiBillNo: gochiBillNoo
        };
        await actions.getGochiOneToN(searchKey).then(data => {
          checkSession(data);
        });
        updateOpenEditProgress(false);
        setOpenFullRefundPopup(false);
      } else {
        updateOpenEditProgress(false);
        updateCheckDisable(false);
      }
    };

    return (
      <div className={classes.root}>
        <div className={classes.titleContent}>
          {`{ ${chargeAmount} } 円を全部返金しましょうか？`}
        </div>
        <div className={classes.btnCloseDiv}>
          <Button onClick={closeAction} color="primary">
            キャンセル
          </Button>
          <Button onClick={callRefund} disabled={checkDisable} color="primary">
            返金
          </Button>
        </div>
        <ProgressDialog
          openProgress={openEditProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
